import React, { FC } from 'react';
import { Button, Card, Flex, Heading, Text } from '@resideo/blueprint-react';
import { useTranslation } from 'react-i18next';
import Page from 'components/common/Page';
import WrenchIcon from 'components/icons/wrench-control-tool.svg?react';
import { STATUS_PAGE_URL } from 'config';
import { IconCircle } from './MaintenancePage.style';

const MaintenancePage: FC = () => {
  const { t } = useTranslation();

  return (
    <Page as='main' data-test-maintenance-page>
      <Card borderRadius={[0, 'medium']} padding='large'>
        <Flex alignItems='center' marginBottom='medium'>
          <IconCircle>
            <WrenchIcon />
          </IconCircle>
          <Heading as='h1' fontSize='xLarge' marginLeft='medium'>
            {t('maintenance.header')}
          </Heading>
        </Flex>
        <Text marginBottom='medium'>{t('maintenance.content')}</Text>
        {STATUS_PAGE_URL && (
          <Button
            href={STATUS_PAGE_URL}
            target='_blank'
            rel='noopener noreferrer'>
            {t('maintenance.checkStatus')}
          </Button>
        )}
      </Card>
    </Page>
  );
};

export default MaintenancePage;
